export default __webpack_public_path__ + "static/fibg-overlay-433667957619c55f2a9d1838c12719e6.jpg";